export var financial = {
    900: '#EE701F',
    800: '#F18D23',
    700: '#F29E25',
    600: '#F3AE28',
    500: '#F4BB2D',
    400: '#F6C53C',
    300: '#F7D05A',
    200: '#F9DC87',
    100: '#FCEAB6',
    50: '#FEF7E2',
};
//# sourceMappingURL=financial.js.map